<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper">
        <div class="col-lg-7">
          <div class="element-box mb-0">
            <form @submit="refresh">
              <h5 class="form-header">Kardex</h5>
              <P></P>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          current.errors.producto &&
                          current.errors.producto.length > 0,
                      }"
                    ></label>
                    <ProductoSelectComponentV2
                      @onChangeProducto="onChangeProducto"
                      :current="current"
                    ></ProductoSelectComponentV2>
                    <small
                      v-if="current.errors && current.errors.producto"
                      class="form-text text-danger"
                      >{{ current.errors.producto[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-md-12">
                  <TiendaSelectComponent :current="current" />
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          current.errors.fecha_inicial &&
                          current.errors.fecha_inicial.length > 0,
                      }"
                      >Fecha Inicial</label
                    >
                    <datepicker
                      :format="'dd/MM/yyyy'"
                      :bootstrap-styling="true"
                      v-bind:class="{
                        'is-invalid':
                          current.errors.fecha_inicial &&
                          current.errors.fecha_inicial.length > 0,
                      }"
                      v-model="current.fecha_inicial"
                    ></datepicker>
                    <small
                      v-if="current.errors && current.errors.fecha_inicial"
                      class="form-text text-danger"
                      >{{ current.errors.fecha_inicial[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          current.errors.fecha_final &&
                          current.errors.fecha_final.length > 0,
                      }"
                      >Fecha Final</label
                    >
                    <datepicker
                      :format="'dd/MM/yyyy'"
                      :bootstrap-styling="true"
                      v-bind:class="{
                        'is-invalid':
                          current.errors.fecha_final &&
                          current.errors.fecha_final.length > 0,
                      }"
                      v-model="current.fecha_final"
                    ></datepicker>
                    <small
                      v-if="current.errors && current.errors.fecha_final"
                      class="form-text text-danger"
                      >{{ current.errors.fecha_final[0] }}</small
                    >
                  </div>
                </div>
              </div>
              <div class="form-buttons-w">
                <router-link
                  v-if="current.producto"
                  class="btn btn-outline-info"
                  :to="{
                    name: 'cat-productos-editar',
                    params: { sku: current.producto.sku },
                  }"
                >
                  <i class="fa fa-arrow-left"></i>
                  Ir al Producto
                </router-link>
                <button class="btn btn-md btn-success" type="submit">
                  Refrescar
                </button>
                &nbsp;
                <span v-if="datos[0]" class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Exportar Reporte
                  </button>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <a class="dropdown-item" @click="imprimirXls(current)"
                      >.XLS</a
                    >
                    <a class="dropdown-item" @click="imprimirPdf(current)"
                      >.PDF</a
                    >
                  </div>
                </span>
              </div>
            </form>

            <div class="row"></div>
          </div>
        </div>
        <div class="col-lg-5 pt-2 color-scheme-dark" v-if="current.producto">
          <ProductoTiendaTableComponent
            v-if="current.producto"
            :current="current.producto"
            @refresh="onChangeProducto"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="element-wrapper">
            <div class="element-box">
              <div class="table-responsive">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Sku</th>
                      <th>#</th>
                      <th>Fecha</th>
                      <th>Tipo</th>
                      <th class="text-right">Minimo</th>
                      <th class="text-right">Maximo</th>
                      <th class="text-right">Cantidad</th>
                      <th class="text-right">Solicitado</th>
                      <th class="text-right">Pendiente</th>
                      <th class="text-right">Acumulado</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in datos" :key="item.id">
                      <td style="color: DodgerBlue">
                        {{ item.sku }}
                      </td>
                      <td>
                        <span v-if="item.tipo != 'INV_INICIAL'">{{
                          item.id
                        }}</span>
                      </td>
                      <td>
                        <span v-if="item.tipo != 'INV_INICIAL'">{{
                          customFormatterFechaHora(item.fecha)
                        }}</span>
                      </td>
                      <td>
                        {{ item.tipo_str }}
                      </td>
                      <td class="text-right">
                        {{ producto.minimo }}
                      </td>
                      <td class="text-right">
                        {{ producto.maximo }}
                      </td>
                      <td class="text-right">
                        <span
                          class="text-success"
                          v-if="
                            item.cantidad >= 0 && item.tipo != 'REQ_TRASLADO'
                          "
                          >+ {{ item.cantidad }}</span
                        >
                        <span class="text-danger" v-if="item.cantidad < 0">{{
                          item.cantidad
                        }}</span>
                      </td>
                      <td class="text-right">
                        <span
                          class="text-info"
                          v-if="item.tipo == 'REQ_TRASLADO'"
                          >+ {{ item.solicitada }}</span
                        >
                      </td>
                      <td class="text-right">
                        <span
                          class="text-info"
                          v-if="
                            item.pendiente > 0 &&
                            item.pendiente != 'REQ_TRASLADO'
                          "
                          >+ {{ item.pendiente }}</span
                        >
                      </td>
                      <td class="text-right">
                        <span
                          style="color: DodgerBlue"
                          v-if="item.acumulado >= 0"
                          >{{ item.acumulado }}</span
                        >
                        <span class="text-danger" v-if="item.acumulado < 0">{{
                          item.acumulado
                        }}</span>
                      </td>
                      <td class="text-right">
                        <div v-if="item.tipo != 'INV_INICIAL'">
                          <router-link
                            target="_blank"
                            v-if="item.tipo == 'ENVIOS'"
                            class="btn btn-outline-success btn-sm"
                            :to="{
                              name: 'inventario-envio_inventario-editar',
                              params: { id: item.trans_id },
                            }"
                          >
                            <i class="fas fa-eye"></i>
                          </router-link>
                          <router-link
                            target="_blank"
                            v-if="item.tipo == 'INGRESOXTRASLADO'"
                            class="btn btn-outline-success btn-sm"
                            :to="{
                              name: 'inventario-entrada_traslado-editar',
                              params: { id: item.trans_id },
                            }"
                          >
                            <i class="fas fa-eye"></i>
                          </router-link>
                          <router-link
                            target="_blank"
                            v-if="item.tipo == 'CONVER'"
                            class="btn btn-outline-success btn-sm"
                            :to="{
                              name: 'inventario-conversiones-editar',
                              params: { id: item.trans_id },
                            }"
                          >
                            <i class="fas fa-eye"></i>
                          </router-link>
                          <router-link
                            target="_blank"
                            v-if="item.tipo == 'SALIDAXTRASLADO'"
                            class="btn btn-outline-success btn-sm"
                            :to="{
                              name: 'inventario-salida_traslado-editar',
                              params: { id: item.trans_id },
                            }"
                          >
                            <i class="fas fa-eye"></i>
                          </router-link>
                          <router-link
                            target="_blank"
                            v-if="item.tipo == 'ENTRADAXCOMPRA'"
                            class="btn btn-outline-success btn-sm"
                            :to="{
                              name: 'inventario-entrada_compra-editar',
                              params: { id: item.trans_id },
                            }"
                          >
                            <i class="fas fa-eye"></i>
                          </router-link>
                          <router-link
                            target="_blank"
                            v-if="item.tipo == 'DEVOLUCION_PROVEEDOR'"
                            class="btn btn-outline-success btn-sm"
                            :to="{
                              name: 'inventario-devoluciones_proveedor-editar',
                              params: { id: item.trans_id },
                            }"
                          >
                            <i class="fas fa-eye"></i>
                          </router-link>
                          <router-link
                            target="_blank"
                            v-if="item.tipo == 'DEVOLUCION'"
                            class="btn btn-outline-success btn-sm"
                            :to="{
                              name: 'inventario-devoluciones-editar',
                              params: { id: item.trans_id },
                            }"
                          >
                            <i class="fas fa-eye"></i>
                          </router-link>
                          <router-link
                            target="_blank"
                            v-if="item.tipo == 'AJUSTE'"
                            class="btn btn-outline-success btn-sm"
                            :to="{
                              name: 'inventario-ajuste_inventario-editar',
                              params: { id: item.trans_id },
                            }"
                          >
                            <i class="fas fa-eye"></i>
                          </router-link>
                          <router-link
                            target="_blank"
                            v-if="item.tipo == 'REQ_TRASLADO'"
                            class="btn btn-outline-success btn-sm"
                            :to="{
                              name: 'inventario-req_traslado-editar',
                              params: { id: item.trans_id },
                            }"
                          >
                            <i class="fas fa-eye"></i>
                          </router-link>
                          <router-link
                            target="_blank"
                            v-if="item.tipo == 'SALIDA'"
                            class="btn btn-outline-success btn-sm"
                            :to="{
                              name: 'inventario-salida_inventario-editar',
                              params: { id: item.trans_id },
                            }"
                          >
                            <i class="fas fa-eye"></i>
                          </router-link>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import ReqTrasladoService from "@/services/inventario/ReqTrasladoService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductoUnidadMedidaSelectComponent from "@/components/commons/ProductoUnidadMedidaSelectComponent";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import DynamicService from "@/services/commons/DynamicService";
import ProductoTiendaTableComponent from "@/components/cat/productos/ProductoTiendaTableComponent";

export default {
  components: {
    TiendaSelectComponent,
    ProductoUnidadMedidaSelectComponent,
    ProductoSelectComponentV2,
    ProductoTiendaTableComponent,
  },
  data() {
    return {
      producto: "",
      codigo_barra: null,
      current: {
        producto: "",
        fecha_final: null,
        fecha_inicial: null,
        tienda: null,
        errors: {
          productos: null,
          fecha_inicial: null,
          fecha_final: null,
        },
      },
      datos: [],
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  watch: {
    $route(to, from) {
      if (this.$route.params.tienda) {
        this.current.tienda = this.$route.params.tienda;
        this.refresh();
      }
    },
  },
  mounted() {
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.current.fecha_final = self.customFormatterInverted(
        res.data.fecha_actual
      );
      var f_actual = new Date(self.current.fecha_final);
      self.current.fecha_inicial = new Date(
        new Date(f_actual).setDate(f_actual.getDate() - 16)
      );
    });
    if (this.$route.params.sku) {
      self.refreshProducto(this.$route.params.sku);
    }
    if (this.$route.params.tienda) {
      self.current.tienda = this.$route.params.tienda;
    }
  },
  methods: {
    refreshProductoTienda() {
      DynamicService.fetch("cat", "producto-tienda", {
        producto: this.current.producto.sku,
        tienda: this.current.tienda,
      }).then((response) => {
        this.producto = response.data.results[0];
      });
    },
    imprimirPdf(current) {
      let self = this;
      current.fecha_final = moment(current.fecha_final).format("YYYY-MM-DD");
      if (current.fecha_inicial) {
        current.fecha_inicial = moment(current.fecha_inicial).format(
          "YYYY-MM-DD"
        );
      }
      this.fecha_inicial = "fecha_inicial=";
      if (current.fecha_inicial == null) {
        this.fecha_inicial = "";
        current.fecha_inicial = "";
      }
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=inventario/kardex/kardex.jrxml&tienda=${current.tienda}&producto=${current.producto.sku}&${this.fecha_inicial}${current.fecha_inicial}&fecha_fin=${current.fecha_final}`
      );
      current.proveedor = "";
    },
    imprimirXls(current) {
      let self = this;
      current.fecha_final = moment(current.fecha_final).format("YYYY-MM-DD");
      if (current.fecha_inicial) {
        current.fecha_inicial = moment(current.fecha_inicial).format(
          "YYYY-MM-DD"
        );
      }
      this.fecha_inicial = "fecha_inicial=";
      if (current.fecha_inicial == null) {
        this.fecha_inicial = "";
        current.fecha_inicial = "";
      }
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_format=xls&report_name=inventario/kardex/kardex.jrxml&tienda=${current.tienda}&producto=${current.producto.sku}&${this.fecha_inicial}${current.fecha_inicial}&fecha_fin=${current.fecha_final}`
      );
      current.proveedor = "";
    },
    onChangeProducto(producto) {
      let self = this;
      self.refreshProducto(self.current.producto.sku);
      // self.refreshUnidadMedida(producto);
    },
    refreshProducto(sku) {
      let self = this;
      let _p = {
        render_precios: false,
      };
      ProductosService.getById(sku, _p).then((response) => {
        self.current.producto = response.data;
      });
    },
    refresh(e) {
      if (e) {
        e.preventDefault();
      }
      let self = this;
      let params = Object.assign({}, self.current);
      if (params.fecha_inicial) {
        params.fecha_inicial = moment(params.fecha_inicial).format(
          "DD/MM/YYYY"
        );
      }
      if (params.fecha_final) {
        params.fecha_final = moment(params.fecha_final).format("DD/MM/YYYY");
      }
      if (params.fecha_inicial == null) {
        delete params.fecha_inicial;
      }
      DynamicService.postAction(
        "cat",
        "productos",
        self.current.producto.sku,
        "kardex_x_fecha_json",
        params
      )
        .then((res) => {
          self.datos = res.data;
          this.refreshProductoTienda();
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    },
    customFormatter(date) {
      var d = date.toString().split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];
      return moment(str_d).format("DD/MM/YYYY");
    },

    customFormatterInverted(date) {
      var d = date.split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];
      return moment(str_d).add(1, "days").format("YYYY-MM-DD");
    },

    customFormatterFechaHora(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
  },
};
</script>
